export default __webpack_public_path__ + "static/media/card4.f1b80bad.png";